import {v4 as uuidv4} from 'uuid';
import thumb1 from '../../assets/img/blog/b1.jpg';
import thumb2 from '../../assets/img/blog/b2.jpg';
import thumb3 from '../../assets/img/blog/b3.jpg';
import authorImg from '../../assets/img/blog/author2.jpg';
import authorImg1 from '../../assets/img/blog/author3.jpg';

const blogOneData = [
    {
        id: uuidv4(),
        thumb: thumb1,
        title: 'empowering-agri-industrial-growth',
        btnText: 'Read More',
        btnLink: '/blog/empowering-agri-industrial-growth',
        authorName: 'Busico',
        authorImg: authorImg,
        date: '28 MAY 2022'
    },

    
]

export default blogOneData;